module.exports = __webpack_public_path__ + "static/Flavor_18AMT90222-32768c667373ed42cd7a0c9584c65b4d.pdf";